// The share of their book an advisor meets in person in a year, the same
// however big the book: 40%, a round figure for what a year's client
// meetings have room for. Kitces Research found US lead advisors spend 8.8
// hours a week meeting clients, under a fifth of their time, 3.6 to 5.4 hours
// a client a year ("How Do Financial Advisors Actually Spend Their Time?",
// March 2019, over 1,000 advisors:
// https://www.kitces.com/blog/how-do-financial-advisors-spend-time-research-study-productivity-capacity-efficiency/).
// Over 48 working weeks, at 4 hours a client, that is 105 clients, 42% of the
// default book below. The 71 to 118 clients Kitces found US lead advisors
// serving would be 32% to 54% of it. The time data is from the US: no
// Italian survey measures it.
export const MET_SHARE = 0.4;

// The fewest clients the hero takes: with fewer, they are too few dots to
// draw AVRAH's mark (hero-v2/shapes/markTargets.js), which reads only from
// about 40.
export const MIN_CLIENTS = 50;
export const MAX_CLIENTS = 1500;
// A round figure a little above the average book of an Italian financial
// advisor, 220 (Anasf, Centro Studi e Ricerche, sixth survey, December 2025,
// 370 advisors).
export const DEFAULT_CLIENTS = 250;

// The hero input is free text; anything unusable falls back to the default,
// and anything out of bounds is taken to the nearest bound.
export function parseClients(raw) {
  const value = parseFloat(String(raw).replace(",", "."));
  if (!Number.isFinite(value) || value <= 0) return DEFAULT_CLIENTS;
  return Math.round(Math.min(MAX_CLIENTS, Math.max(MIN_CLIENTS, value)));
}

// "1 cliente", "250 clienti": a client count as Italian copy reads it.
export function clientsLabel(clients) {
  return `${clients.toLocaleString("it-IT")} ${clients === 1 ? "cliente" : "clienti"}`;
}

// The clients you meet in a year, MET_SHARE of them to the nearest client,
// and the others. The share is under a half, so there are always others,
// however small the book.
export function presenceFor(clients) {
  const met = Math.round(clients * MET_SHARE);
  return { met, others: clients - met };
}
